import { getYearFromString, WidgetComponent } from '@flexfront/ui/react';
import RetirementIconCardComponent from '../icon-card-component/retirement-icon-card-component';
import IconCardComponent from '../icon-card-component/icon-card-component';
import './i-want-component.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import PreserveCapitalIconCardComponent from '../icon-card-component/preserve-capital-icon-card-component';
import { useGoalsContext } from '../../../common/providers/goals-provider';
import { useDashboardContext } from '../../../common/providers/dashboard-provider';

export function IWantComponent() {
  const {
    labels: iWantLabels,

    iWantIcon,
    swiperContainerRef,
    onSwiperContainerKeyUp,
    setSwiperInstance,

    retirement,
    isRetirementIconHidden,
    onRetirementChange,
    onRetirementAgeBlur,
    currencyConfig,
    onRetirementMonthlyPayoutBlur,
    isRetirementYearValid,

    isLegacyHidden,
    isLegacyIconHidden,
    onLegacyChange,
    legacy,
    onLegacyBlur,

    isDreamHidden,
    dream,
    isDreamIconHidden,
    onDreamChange,
    onDreamYearBlur,
    onDreamPayoutBlur,
    isDreamYearValid,

    isPreserveCapitalHidden,
    preserveCapital,
    isPreserveCapitalIconHidden,
    currentYear,
    yearOfDeath,
    onPreserveCapitalChange,
    onPreserveCapitalValidate,
    onPreserveCapitalFromYearBlur,
    onPreserveCapitalToYearBlur,
    onPreserveCapitalAmountBlur,

    isSecureFamilyHidden,
    secureFamily,
    isSecureFamilyIconHidden,
    onSecureFamilyChange,
    onSecureFamilyYearBlur,
    onSecureFamilyPayoutBlur,
    isSecureFamilyYearValid,

    goalsOrder,
  } = useGoalsContext();

  const {
    iWantOrder
  } = useDashboardContext();

  function renderGoals() {
    let lastTabIndex = +`${iWantOrder}1`;
    return goalsOrder.map((goal, index) => {
      switch (goal) {
        case 'RETIREMENT':
          return (
            <SwiperSlide key={index}>
              <RetirementIconCardComponent
                tabIndex={(lastTabIndex += 2)}
                valuePlaceholder={iWantLabels.GOALS.RETIREMENT.AMOUNT_PLACEHOLDER}
                agePlaceholder={iWantLabels.GOALS.RETIREMENT.AGE_PLACEHOLDER}
                titleLabel={iWantLabels.GOALS.RETIREMENT.TITLE}
                valueLabel={iWantLabels.GOALS.RETIREMENT.WHEN}
                totalLabel={iWantLabels.GOALS.RETIREMENT.AMOUNT}
                retirementAge={retirement.retirementAge}
                retirementMonthlyPayout={retirement.retirementMonthlyPayout}
                iconClassName="icon-pension"
                hideIcon={isRetirementIconHidden}
                onRetirementChange={onRetirementChange}
                currencyConfig={currencyConfig}
                onRetirementAgeBlur={onRetirementAgeBlur}
                onRetirementMonthlyPayoutBlur={onRetirementMonthlyPayoutBlur}
                isRetirementYearValid={isRetirementYearValid}
              />
            </SwiperSlide>
          );
        case 'LEGACY':
          return !isLegacyHidden && (
            <SwiperSlide key={index}>
              <IconCardComponent
                tabIndex={(lastTabIndex += 2)}
                valueLabel={iWantLabels.GOALS.LEGACY.TITLE}
                valuePlaceholder={iWantLabels.GOALS.LEGACY.AMOUNT_PLACEHOLDER}
                totalLabel={iWantLabels.GOALS.GOAL.AMOUNT}
                iconClassName="icon-legacy"
                hideIcon={isLegacyIconHidden}
                onChange={onLegacyChange}
                inputNumber={legacy.amount}
                displayNumber={legacy.amount}
                currencyConfig={currencyConfig}
                onBlur={onLegacyBlur}
              />
            </SwiperSlide>
          );
        case 'DREAM':
          return !isDreamHidden && (
            <SwiperSlide key={index}>
              <RetirementIconCardComponent
                tabIndex={(lastTabIndex += 1)}
                valueLabel={iWantLabels.WHEN}
                cardClassName={dream.hasInvalidDate ? 'error error-border' : ''}
                titleLabel={iWantLabels.GOALS.GOAL.TITLE}
                valuePlaceholder={iWantLabels.GOALS.GOAL.AMOUNT_PLACEHOLDER}
                agePlaceholder={iWantLabels.GOALS.GOAL.YEAR_PLACEHOLDER}
                totalLabel={iWantLabels.GOALS.GOAL.AMOUNT}
                retirementAge={dream.year}
                retirementMonthlyPayout={dream.amount}
                iconClassName="icon-dream"
                hideIcon={isDreamIconHidden}
                onRetirementChange={onDreamChange}
                currencyConfig={currencyConfig}
                onRetirementAgeBlur={onDreamYearBlur}
                onRetirementMonthlyPayoutBlur={onDreamPayoutBlur}
                isRetirementYearValid={isDreamYearValid}
              />
            </SwiperSlide>
          );
        case 'PRESERVE_CAPITAL':
          return !isPreserveCapitalHidden && (
            <SwiperSlide key={index}>
              <PreserveCapitalIconCardComponent
                tabIndex={(lastTabIndex += 2)}
                cardClassName={preserveCapital.hasInvalidDate ? 'error error-border' : ''}
                dateErrorLabels={iWantLabels.GOALS.PRESERVE_CAPITAL?.DATE_ERRORS}
                titleLabel={iWantLabels.GOALS.PRESERVE_CAPITAL?.TITLE}
                valueLabel={iWantLabels.WHEN}
                valuePlaceholder={iWantLabels.GOALS.PRESERVE_CAPITAL?.AMOUNT_PLACEHOLDER}
                totalLabel={iWantLabels.GOALS.PRESERVE_CAPITAL?.AMOUNT}
                iconClassName="icon-piggy-bank"
                hideIcon={isPreserveCapitalIconHidden}
                minYear={currentYear}
                maxYear={yearOfDeath}
                fromYear={getYearFromString(preserveCapital.startDate) ?? currentYear}
                toYear={getYearFromString(preserveCapital.endDate) ?? yearOfDeath}
                amount={preserveCapital.amount}
                onChange={onPreserveCapitalChange}
                onValidate={onPreserveCapitalValidate}
                currencyConfig={currencyConfig}
                onFromYearBlur={onPreserveCapitalFromYearBlur}
                onToYearBlur={onPreserveCapitalToYearBlur}
                onAmountBlur={onPreserveCapitalAmountBlur}
              />
            </SwiperSlide>
          );
        case 'SECURE_FAMILY':
          return !isSecureFamilyHidden && (
            <SwiperSlide key={index}>
              <RetirementIconCardComponent
                tabIndex={(lastTabIndex += 2)}
                cardClassName={secureFamily.hasInvalidDate ? 'error error-border' : ''}
                titleLabel={iWantLabels.GOALS.SECURE_FAMILY.TITLE}
                valueLabel={iWantLabels.WHEN}
                valuePlaceholder={iWantLabels.GOALS.SECURE_FAMILY.AMOUNT_PLACEHOLDER}
                agePlaceholder={iWantLabels.GOALS.SECURE_FAMILY.YEAR_PLACEHOLDER}
                totalLabel={iWantLabels.GOALS.SECURE_FAMILY.AMOUNT}
                retirementAge={secureFamily.year}
                retirementMonthlyPayout={secureFamily.amount}
                iconClassName="icon-secure-family"
                hideIcon={isSecureFamilyIconHidden}
                onRetirementChange={onSecureFamilyChange}
                currencyConfig={currencyConfig}
                onRetirementAgeBlur={onSecureFamilyYearBlur}
                onRetirementMonthlyPayoutBlur={onSecureFamilyPayoutBlur}
                isRetirementYearValid={isSecureFamilyYearValid}
              />
            </SwiperSlide>
          );
        default:
          return null;
      }
    });
  }

  return (
    <WidgetComponent className="i-want-component widget--slider" isExpanded={false}>
      <div className="widget-title-container">
        {iWantIcon && <span className="widget-title-icon" dangerouslySetInnerHTML={{ __html: iWantIcon ?? '' }}></span>}
        <h3 className="widget-title">{iWantLabels.TITLE}</h3>
      </div>
      <div className="swiper-component" ref={swiperContainerRef} onKeyUp={onSwiperContainerKeyUp}>
        <Swiper
          onSwiper={setSwiperInstance}
          spaceBetween={4}
          slidesPerView={2}
          pagination={{ clickable: true, enabled: true }}
          modules={[Pagination]}
        >
          {renderGoals()}
        </Swiper>
      </div>
    </WidgetComponent>
  );
}

export default IWantComponent;
